import objectFitImages from 'object-fit-images';

jQuery(document).ready(function() {
    objectFitImages();
});
